import { render, staticRenderFns } from "./ReceiptStatus.vue?vue&type=template&id=3af56e5f"
import script from "./ReceiptStatus.vue?vue&type=script&lang=js"
export * from "./ReceiptStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af56e5f')) {
      api.createRecord('3af56e5f', component.options)
    } else {
      api.reload('3af56e5f', component.options)
    }
    module.hot.accept("./ReceiptStatus.vue?vue&type=template&id=3af56e5f", function () {
      api.rerender('3af56e5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search/result/ReceiptStatus.vue"
export default component.exports